
import PropTypes from "prop-types";

// MUI components
import FaiBox from "../../MuiComponents/FaiBox";
import FaiTypography from "../../MuiComponents/FaiTypography";
import FaiInput from "../../MuiComponents/FaiInput";

function FormField({ label, ...rest }) {
  return (
    <>
        {label !== undefined && <FaiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <FaiTypography
                component="label"
                variant="caption"
                fontWeight="bold"
                textTransform="capitalize"
            >
                {label}
            </FaiTypography>
        </FaiBox>}
      <FaiInput {...rest} />
    </>
  );
}

// typechecking props for FormField
FormField.propTypes = {
  label: PropTypes.string.isRequired,
};

export default FormField;
